import RoundedButtonPrimary from '../../../components/button/rounded-button-primary/RoundedButtonPrimary';
import CreateProjectButton from '../../../components/create-project-button/CreateProjectButton';
import Image from '../../../components/image/Image';
import { isOrganizationIdrettslag } from '../../organization-model';
import {
    OrganizationTheme,
    PRIMARY_ORGANIZATION_COLOR,
    SECONDARY_ORGANIZATION_COLOR,
} from '../../theme/OrganizationTheme';
import { useOrganization } from '../../useOrganization';

import styles from './organization-start-project.module.less';
import { Heading2 } from '@sb1/ffe-core-react';

const OrganizationStartProject = () => {
    const organization = useOrganization();
    const isIdrettslag = isOrganizationIdrettslag({ organization });

    const linkParams = `?organizationId=${organization.id}&skipWizardField=payout_to`;

    const link = isIdrettslag
        ? `/project/select/template?provider=organization&organizationId=${organization.id}`
        : undefined;

    const content = (
        <div className={styles.outerWrapper}>
            <Image
                className={styles.illustration}
                src={'/public/images/hand-hjerte.svg'}
                alt="Illustrasjon av en hånd som holder et hjerte"
            />
            <div className={styles.innerWrapper}>
                <Heading2 lookLike={3} className={styles.title}>
                    Start din egen spleis for {organization.name}
                </Heading2>
                <p>
                    Sett i gang din egen spleis for en sak du bryr deg om, og engasjer familie, venner og kjente til å
                    bidra sammen med deg.
                </p>
                <CreateProjectButton
                    linkParams={linkParams}
                    buttonElement={RoundedButtonPrimary}
                    className={[styles.startSpleisButton, PRIMARY_ORGANIZATION_COLOR].join(' ')}
                    alternativeLink={link}
                />
            </div>
        </div>
    );

    return <OrganizationTheme theme={SECONDARY_ORGANIZATION_COLOR}>{content}</OrganizationTheme>;
};

export default OrganizationStartProject;
